export default __webpack_public_path__ + "static/grow-c01278e077b9b461fd8a7cf3d93f00ed.png";